module.exports = __webpack_public_path__ + "23599a13d16363253f71092203008477.svg";